export default __webpack_public_path__ + "static/media/content.7d2a7376.png";